<template>
    <div class='myOrder'>
        <myBanner :imgSrc="imgSrc"/>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item><span @click="$router.go(-1)">返回</span></el-breadcrumb-item>
            <el-breadcrumb-item>我的订单</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="showMobile">
            <div class="dashed"></div>
        </div>
        <!-- 表格区域 -->
        <div class="content showPc">
             <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane name="first">
                    <span slot="label"><i class="el-icon-s-promotion"></i> 留学订单</span>
                    <el-table
                        :data="tableData"
                        stripe
                        style="width: 100%">
                        <el-table-column align="center" prop="orderNumber" width="180px" label="订单编号"></el-table-column>
                        <el-table-column align="center" prop="parentId" label="订单类型">
                            <template slot-scope="scope">
                                {{scope.row.parentId == 0 ? '获取offer' : '获取签证'}}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" prop="studentName" label="申请人"> </el-table-column>
                        <el-table-column align="center" prop="orderName" label="名称" width="150px" :show-overflow-tooltip="true"></el-table-column>
                        <el-table-column align="center" prop="schoolName" width="150px" :show-overflow-tooltip="true" label="申请学校"></el-table-column>
                        <el-table-column align="center" prop="levelName" label="留学层次"></el-table-column>
                        <el-table-column align="center" label="金额" width="100px">
                            <template slot-scope="scope">
                                {{scope.row.price ? '¥' + scope.row.price : '0'}}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="支付状态" width="100px">
                            <template slot-scope="scope">
                                <el-tag type="danger" v-if='scope.row.payStatus==1'>待支付</el-tag>
                                <el-tag type="success" v-else-if="scope.row.payStatus==2">支付成功</el-tag>
                                <el-tag type="warning" v-else-if="scope.row.payStatus==3">转入退款</el-tag>
                                <el-tag v-else>已退款</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="订单进展">
                            <template slot-scope="scope">
                                {{scope.row.orderStatus == 1 ? '进行中' : '已完成'}}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="操作" width="150px"> 
                            <template slot-scope="scope">
                                <el-button size="mini" type="primary" plain @click="goDetail(scope.row.id)">查看</el-button>
                                <el-button size="mini" type="info" plain @click="orderDelete(scope.row.id)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane name="second">
                    <span slot="label"><i class="el-icon-s-management"></i> 培训订单</span>
                    <el-table
                        :data="trainData"
                        stripe
                        class="tableName">
                        <el-table-column align="center" prop="orderNumber" label="订单编号" width="180px"> </el-table-column>
                        <el-table-column align="center" label="订单类型">学习培训</el-table-column>
                        <el-table-column align="center" label="申请人">
                            <template slot-scope="scope">
                                {{scope.row.studentName ? scope.row.studentName : '暂无数据'}}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" prop="trainingName" label="培训课程名称"> </el-table-column>
                        <el-table-column align="center" prop="schoolName" label="培训单位" width="220px" :show-overflow-tooltip="true"> </el-table-column>
                        <el-table-column align="center" label="支付状态" width="100px">
                            <template slot-scope="scope">
                                <el-tag type="danger" v-if='scope.row.payStatus==1'>待支付</el-tag>
                                <el-tag type="success" v-else-if="scope.row.payStatus==2">支付成功</el-tag>
                                <el-tag type="warning" v-else-if="scope.row.payStatus==3">转入退款</el-tag>
                                 <el-tag type="success" v-else-if="scope.row.payStatus==5">已分期</el-tag>
                                <el-tag v-else>已退款</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="订单进展">
                            <template slot-scope="scope">
                                {{scope.row.orderStatus == 1 ? '进行中' : '已完成'}}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="操作" width="150px"> 
                            <template slot-scope="scope">
                                <el-button size="mini" type="primary" plain @click="goTrainDetail(scope.row.id)">查看</el-button>
                                <el-button size="mini" type="info" plain @click="trainDelete(scope.row.id)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane name="third">
                    <span slot="label"><i class="el-icon-menu"></i> 通用订单</span>
                    <el-table
                        :data="commonOrderData"
                        stripe
                        class="tableName">
                        <el-table-column align="center" prop="orderNumber" label="订单编号" width="180px" :show-overflow-tooltip="true"> </el-table-column>
                        <el-table-column align="center" prop="orderName" label="订单名称" width="150px" :show-overflow-tooltip="true"></el-table-column>
                        <el-table-column align="center" label="姓名" :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                {{scope.row.customerName ? scope.row.customerName : '暂无'}}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="电话"  width="120px">
                            <template slot-scope="scope">
                                {{scope.row.mobile ? scope.row.mobile : '暂无'}}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="地址"  :show-overflow-tooltip="true" >
                            <template slot-scope="scope">
                                {{scope.row.address ? scope.row.address : '暂无'}}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="金额">
                            <template slot-scope="scope">
                                {{scope.row.price ? '¥' + scope.row.price : '0'}}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="支付状态" width="100px">
                            <template slot-scope="scope">
                                <el-tag type="danger" v-if='scope.row.payStatus==1'>待支付</el-tag>
                                <el-tag type="success" v-else-if="scope.row.payStatus==2">支付成功</el-tag>
                                <el-tag type="warning" v-else-if="scope.row.payStatus==3">转入退款</el-tag>
                                <el-tag v-else>已退款</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="支付时间"  :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                {{scope.row.payEndTime ? scope.row.payEndTime : '暂未支付'}}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="备注" :show-overflow-tooltip="true"> 
                            <template slot-scope="scope">
                                {{scope.row.remarks ? scope.row.remarks : '暂无'}}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="操作" width="150px"> 
                            <template slot-scope="scope">
                                <el-button size="mini" type="primary" plain @click="getPayOrder(scope.row.orderNumber,scope.row.orderName,scope.row.price)" v-if="scope.row.payStatus == 1">付款</el-button>
                                <el-button size="mini" type="primary" plain v-if="scope.row.payStatus != 1">--</el-button>
                                <el-button size="mini" type="info" plain @click="commonDelete(scope.row.id)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
            <el-pagination
                class="page"
                background
                :total="total"
                :page-size="pageSize"
                @current-change="changePage"
                layout="prev, pager, next"
                ref="pagination">
            </el-pagination>
        </div>
        <div class="showMobile mobileTable">
            <el-tabs v-model="activeName" @tab-click="handleClick" class="elTables">
                <el-tab-pane label="留学订单" name="first">
                    <template v-for="(item,index) in tableData">
                        <div class="orderItem first" :key="index">
                            <div @click="goDetail(item.id)">
                                <div class="title">
                                    <div class="txt">{{item.schoolName}}留学申请订单信息</div>
                                    <div>
                                        <el-button 
                                            size="mini" 
                                            type="info" 
                                            plain
                                            @click.stop="orderDelete(item.id)">
                                                删除
                                        </el-button>
                                    </div>
                                </div>
                                <div class="lineOne">
                                    <div>
                                        <span class="sTitle">订单编号：</span> 
                                        {{item.orderNumber}}
                                    </div>
                                    <div>
                                        <span class="danger" v-if='item.payStatus==1'>待支付</span>
                                        <span class="success" v-else-if="item.payStatus==2">支付成功</span>
                                        <span class="warning" v-else-if="item.payStatus==3">转入退款</span>
                                        <span class="default" v-else>已退款</span>
                                    </div>
                                </div>
                                <div class="line">
                                    <span class="sTitle">订单类型：</span>
                                {{item.parentId == 0 ? '获取offer' : '获取签证'}}
                                </div>
                                <div class="line">
                                    <span class="sTitle">申请人：</span>
                                    {{item.studentName}}
                                </div>
                                <div class="line">
                                    <span class="sTitle">名称：</span>
                                    {{item.orderName}}
                                </div>
                                <div class="line">
                                    <span class="sTitle">申请学校：</span>
                                    {{item.schoolName}}
                                </div>
                                <div class="line">
                                    <span class="sTitle"> 留学层次：</span>
                                    {{item.levelName}}
                                </div>
                                <div class="line">
                                    <span class="sTitle"> 金额：</span>
                                    <span class="price">{{item.price ? '¥' + item.price : '0'}}</span>
                                </div>
                                <div class="line">
                                    <span class="sTitle"> 订单进展：</span>
                                    {{item.orderStatus == 1 ? '进行中' : '已完成'}}
                                </div>
                            </div>
                            <div class="look">
                                <div class="line">
                                    <span class="sTitle"> 合计：</span>
                                    <span class="price">{{item.price ? '¥' + item.price : '0'}}</span>
                                </div>
                                <el-button 
                                    size="mini" 
                                    type="danger" 
                                    v-show="item.payStatus==1"
                                    @click="goPay(item.orderNumber)">
                                        支付
                                </el-button>
                            </div>
                        </div>
                        <div class="garyBorder" :key="item.id"></div>
                    </template>
                    <div class="noDataOrder" v-show="tableData.length" >暂无数据</div>
                </el-tab-pane>
                <el-tab-pane label="培训订单" name="second">
                    <template v-for="(item,index) in trainData">
                        <div class="orderItem first" :key="index+'_1'">
                            <div @click="goTrainDetail(item.id)">
                                <div class="title">
                                    <div class="txt">{{item.trainingName}}培训订单信息</div>
                                    <div>
                                        <el-button 
                                            size="mini" 
                                            type="info" 
                                            plain
                                            @click.stop="trainDelete(item.id)">
                                                删除
                                        </el-button>
                                    </div>
                                </div>
                                <div class="lineOne">
                                    <div>
                                        <span class="sTitle">订单编号：</span> 
                                        {{item.orderNumber}}
                                    </div>
                                    <div>
                                        <span class="danger" v-if='item.payStatus==1'>待支付</span>
                                        <span class="success" v-else-if="item.payStatus==2">支付成功</span>
                                        <span class="warning" v-else-if="item.payStatus==3">转入退款</span>
                                        <span class="success" v-else-if="item.payStatus==5">已分期</span>
                                        <span class="default" v-else>已退款</span>
                                    </div>
                                </div>
                                <div class="line">
                                    <span class="sTitle">订单类型：</span>
                                    学习培训
                                </div>
                                <div class="line">
                                    <span class="sTitle">申请人：</span>
                                    {{item.studentName ? item.studentName : '暂无数据'}}
                                </div>
                                <div class="line">
                                    <span class="sTitle">培训课程名称：</span>
                                    {{item.trainingName}}
                                </div>
                                <div class="line">
                                    <span class="sTitle">培训单位：</span>
                                    {{item.schoolName}}
                                </div>
                                <!-- <div class="line">
                                    <span class="sTitle">支付状态：</span>
                                    已支付
                                </div> -->
                                <div class="line">
                                    <span class="sTitle"> 订单进展：</span>
                                    {{item.orderStatus == 1 ? '进行中' : '已完成'}}
                                </div>
                            </div>
                        </div>
                        <div class="garyBorder mPayItem" :key="item.id"></div>
                    </template>
                    <div class="noDataOrder" v-show="trainData.length" >暂无数据</div>
                </el-tab-pane>
                <el-tab-pane label="通用订单" name="third">
                    <template v-for="(item,index) in commonOrderData">
                        <div class="orderItem first" :key="index + '_2'">
                            <div>
                                <div class="title">
                                    <div class="txt">{{item.orderName}}</div>
                                    <div>
                                        <el-button 
                                            size="mini" 
                                            type="info" 
                                            plain
                                            @click.stop="commonDelete(item.id)">
                                                删除
                                        </el-button>
                                    </div>
                                </div>
                                <div class="lineOne">
                                    <div>
                                        <span class="sTitle">订单编号：</span> 
                                        {{item.orderNumber}}
                                    </div>
                                    <div>
                                        <span class="danger" v-if='item.payStatus==1'>待支付</span>
                                        <span class="success" v-else-if="item.payStatus==2">支付成功</span>
                                        <span class="warning" v-else-if="item.payStatus==3">转入退款</span>
                                        <span class="default" v-else>已退款</span>
                                    </div>
                                </div>
                                <!-- <div class="line">
                                    <span class="sTitle">创建时间：</span>
                                    {{item.createTime}}
                                </div> -->
                                <div class="line">
                                    <span class="sTitle">姓名：</span>
                                    {{item.customerName ? item.customerName : '暂无'}}
                                </div>
                                <div class="line">
                                    <span class="sTitle">电话：</span>
                                    {{item.mobile ? item.mobile : '暂无'}}
                                </div>
                                <div class="line">
                                    <span class="sTitle">地址：</span>
                                    {{item.address ? item.address : '暂无'}} 
                                </div>
                                <div class="line">
                                    <span class="sTitle"> 金额：</span>
                                    <span class="price">{{item.price ? '¥' + item.price : '0'}}</span>
                                </div>
                                <div class="line">
                                    <span class="sTitle">支付时间：</span>
                                    {{item.payEndTime ? item.payEndTime : '暂未支付'}}
                                </div>
                                <div class="line">
                                    <span class="sTitle">备注：</span>
                                    {{item.remarks ? item.remarks : '暂无'}}
                                </div>
                            </div>
                            <div class="look">
                                <div class="line">
                                    <span class="sTitle"> 合计：</span>
                                    <span class="price">{{item.price ? '¥' + item.price : '0'}}</span>
                                </div>
                                <el-button 
                                    size="mini" 
                                    type="danger" 
                                    v-show="item.payStatus==1"
                                    @click="goPay(item.orderNumber)">
                                        支付
                                </el-button>
                            </div>
                        </div>
                        <div class="garyBorder" :key="item.id"></div>
                    </template>
                    <div class="noDataOrder" v-show="commonOrderData.length" >暂无数据</div>
                </el-tab-pane>   
            </el-tabs>
            
        </div>
        <!-- 付款二维码 -->
        <el-dialog
        :visible.sync="codeVisible"
        width="310px"
        center
        :before-close="handleClose">
            <div class="textTip">
                <div> <span>订单名称</span> ：{{codeOrderName}}</div>
                <p class="money"><span>金额</span>：{{'¥' + codePrice}}</p>
            </div>
            <div id="qrcode" ref="qrcode"></div>
            <div class="codeTip">
                请使用微信扫一扫<br/>扫描二维码支付
            </div>
        </el-dialog>
        <!-- 删除提示 -->
        <el-dialog
        title="提示"
        :visible.sync="deleteVisible"
        :width="dialogWidthDelte"
        center>
            <div class="loginTxt" style="text-align:center;font-size:16px;">是否确定删除？</div>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" type="primary" @click="mDeleteOrder()">确 定</el-button>
                <el-button size="medium" @click="deleteVisible = false">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { getDataMixin, payOrderPc } from "common/mixin.js"
    import { getThemeList ,trainOrderList, commonOrderList, commonOrderDelete, trainDelete, orderDelete} from "network/home.js"
    import { orderList } from "network/application.js"
    import getPayOrder from "common/mobilePay"
    export default {
        name:"myOrder",
        mixins:[getDataMixin,payOrderPc],
        data(){
            return{
                imgSrc:[],
                current:1,
                pageSize:10,
                tableData: [],
                total:0,
                tradeType:'NATIVE',
                activeName: 'first',
                trainData:[],
                flag:'overseas',
                commonOrderData:[],
                deleteVisible:false,
                dialogWidthDelte:'80%',
                deleteFlag:'',
                deleteId:''
            }
        },
        created(){
            if(this.$IsMobile()){
                this.tradeType = "JSAPI"
                this.pageSize = 10000
            }
            if(this.linkPage){
                this.current = this.linkPage
                this.$nextTick(() => {
                    this.$refs.pagination.internalCurrentPage = Number(this.current);
                })
            }
            if(this.trainFalg == "train"){
                this.flag = 'train',
                this.activeName = 'second'
                this.trainOrderListData({
                    current:this.current,
                    pageSize:this.pageSize,
                    wxUserId:this.wxUserId
                })
            }else if(this.trainFalg == "common"){
                this.flag = 'common',
                this.activeName = 'third'
                this.commonOrderList()
            }else{
                this.getOrderList()
            }
            this.getThemeListData(1,100)
            
        },
        methods:{
            // --接口请求 --
            getThemeListData(page,pageSize) {
                getThemeList({
                    page,
                    pageSize
                }).then(res => {
                    let data = res.data.records[this.getNavIndex - 1]
                    if(data){   
                        let bannerData = data.themeBanners
                        if(bannerData.length && bannerData.length == 2){
                            for(let i in bannerData){
                                bannerData.push(bannerData[i])
                            }
                            this.imgSrc = bannerData
                        }else if(bannerData.length){
                            this.imgSrc = bannerData
                        }
                    }
                });
            },
            // 订单列表
            getOrderList(){
                orderList({
                    current:this.current,
                    pageSize:this.pageSize,
                    wxUserId:this.wxUserId
                }).then(res=>{
                    this.tableData = res.data.records
                    this.total = res.data.total
                })
            },
            // 培训列表
            trainOrderListData(data){
                trainOrderList(data).then(res=>{
                    if(res.data.records){
                        this.trainData = res.data.records
                        this.total = res.data.total
                    }
                })
            },
            // 通用订单列表
            commonOrderList(){
                commonOrderList({
                    current:this.current,
                    pageSize:this.pageSize,
                }).then(res=>{
                    this.commonOrderData = res.data.records
                    this.total = res.data.total
                })
            },
            // 删除留学订单
            orderDelete(id) {
                if(this.$IsMobile()){
                    this.deleteVisible = true
                    this.deleteId = id
                    this.deleteFlag = "order"
                }else{
                    this.$confirm('此操作将永久删除该订单, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消'
                    })
                    .then(() => {
                        this.orderDeleteRequest(id)
                    })
                }
            },
            orderDeleteRequest(id){
                 orderDelete({
                    id:id,
                    delFlag:1
                })
                .then(res => {
                    this.getOrderList()
                    this.$message.success('删除成功')
                })
                .catch(error => {
                    this.$message.error(error.msg || '删除失败')
                })
            },
            // 点击删除培训订单
            trainDelete(id) {
                if(this.$IsMobile()){
                    this.deleteVisible = true
                    this.deleteId = id
                    this.deleteFlag = "train"
                }else{
                    this.$confirm('此操作将永久删除该订单, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消'
                    })
                    .then(() => {
                        this.trainDeleteRequest(id)
                    })
                }
                
            },
            // 接口请求删除培训订单
            trainDeleteRequest(id){
                trainDelete({
                    id:id,
                    delFlag:1
                })
                .then(res => {
                    this.trainOrderListData({
                        current:this.current,
                        pageSize:this.pageSize,
                        wxUserId:this.wxUserId
                    })
                    this.$message.success('删除成功')
                })
                .catch(error => {
                    this.$message.error(error.msg || '删除失败')
                })
            },
            // 删除通用订单
            commonDelete(id) {
                if(this.$IsMobile()){
                    this.deleteVisible = true
                    this.deleteId = id
                    this.deleteFlag = "common"
                }else{
                    this.$confirm('此操作将永久删除该订单, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消'
                    })
                    .then(() => {
                        this.commonOrderDeleteRequest(id)
                    })
                }
                
            },
            commonOrderDeleteRequest(id){
                commonOrderDelete({
                    id:id,
                    delFlag:1
                })
                .then(res => {
                    this.commonOrderList()
                    this.$message.success('删除成功')
                })
                .catch(error => {
                    this.$message.error(error.msg || '删除失败')
                })
            },

            // 事件-----
            changePage(pageIndex){
                this.current = pageIndex;
                if(this.flag == 'overseas'){
                    this.getOrderList()
                }else if(this.flag == 'common'){
                    this.commonOrderList()
                }else{
                    this.trainOrderListData({
                        current:this.current,
                        pageSize:this.pageSize,
                        wxUserId:this.wxUserId
                    })
                }
            },
            goDetail(id){
                // this.$router.push('/orderDetail?id=' + id)
                this.$router.push({
                    path:'/orderDetail',
                    query:{
                        id:id,
                        page:this.current
                    }
                })
            },
            goTrainDetail(id){
                this.$router.push({
                    path:'/trainOrderDetail',
                    query:{
                        id:id,
                        page:this.current
                    }
                })
            },
            goPay(item){
                getPayOrder({
                    orderNumber:item,
                    tradeType:this.tradeType
                })
            },
            handleClick(tab) {
                this.current = 1
                //动态改变页码上的分页
                this.$nextTick(() => {
                    this.$refs.pagination.internalCurrentPage = 1;
                })
                if(tab.index == 1){
                    this.flag = 'train'
                    this.trainOrderListData({
                        current:this.current,
                        pageSize:this.pageSize,
                        wxUserId:this.wxUserId
                    })
                }else if(tab.index == 0){
                    this.flag = 'overseas'
                    this.getOrderList()
                }else if(tab.index == 2){
                    this.flag = 'common'
                    this.commonOrderList()
                }
                sessionStorage.setItem('tabIndex',tab.index)
            },
            // 移动端删除
            mDeleteOrder(){
                console.log(this.deleteFlag)
                if(this.deleteFlag == "train"){
                    this.trainDeleteRequest(this.deleteId)
                }else if(this.deleteFlag == "order"){
                    this.orderDeleteRequest(this.deleteId)
                }else if(this.deleteFlag == "common"){
                    this.commonOrderDeleteRequest(this.deleteId)
                }
                this.deleteVisible = false
            }
        },
        computed:{
            wxUserId(){
                return localStorage.getItem('wxUserId') ? localStorage.getItem('wxUserId') : ''
            },
            linkPage(){
                return this.$route.query.page ? this.$route.query.page : "" 
            },
            trainFalg(){
                return this.$route.query.flag ? this.$route.query.flag : "" 
            }
        },
        destroyed(){
            sessionStorage.setItem('tabIndex',"")
        },
        watch:{
            $route(){
                this.commonOrderList()
            }
        }
    }
</script>
<style scoped lang="scss">
    #qrcode {
        padding-left:30px;
        height: 200px;
        width: 200px;
    }
    .codeTip{
        text-align: center;
        background:var(--color-main);
        color:#fff;
        width:200px;
        margin:20px auto 0;
        padding:5px 0;
        line-height: 20px;
    }
    .textTip div{
        padding:0 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
    .textTip span{
        font-weight: bold;
    }
    .textTip .money{
        padding:0 30px;
        margin-top:5px;
        margin-bottom: 10px;
    }
    .el-breadcrumb__inner span{
        cursor: pointer;
    }
    .el-table{
        border:1px solid #EBEEF5;
        border-bottom:0;
    }
     .el-table .detail{
        cursor: pointer;
        color:var(--color-main);
    }
    .el-table .inline{
        display: inline-block;
    }
    .page{
        text-align: center;
        margin:20px 0;
    }
    .content{
        margin:30px 0 40px;
    }

@media screen and (max-width: 768px){
    .mobileTable{
       margin:0rem 0 0.3rem;
       font-size:0.32rem;
    }
    .orderItem.first:nth-child(1) .title{
        margin-top:15px;
    }
    .orderItem{
        width:90%;
        margin:0 auto;
        font-size:0.28rem;
        padding-bottom: 0.2rem;
        .title{
            font-size:0.3rem;
            border-bottom: 1px solid #d7dae2;
            padding-bottom:0.2rem;
            display:flex;
            justify-content: space-between;
            align-items: center;
            .txt{
                width:calc(100% - 80px);
            }
        }
        .lineOne{
            display:flex;
            justify-content: space-between;
            padding:0.3rem 0 0.2rem 0;
            border-bottom: 1px solid #d7dae2;
            margin-bottom:0.1rem;
            span.danger{
                color:#f56c6c;
            }
            span.success{
                color:#67c23a;
            }
            span.warning{
                color:#e6a23c;
            }
            span.default{
                color:#409EFF;
            }
        }
        .line{
            color:#727272;
            line-height:0.5rem;
            .sTitle{
                color:var(--color-text);
            }
            .price{
                color:#fa5555;
            }
        }
        .look{
            border-top:1px solid var(--color-border);
            margin:0.1rem 0 0.2rem;
            display:flex;
            padding-top:0.2rem;
            justify-content: space-between;
            .el-button--mini {
                padding: 7px 24px;
            }
        }
    }
    .garyBorder{
        border-bottom:0.15rem solid #f6f3f3;
        margin-bottom:0.4rem;
    }
    .garyBorder.mPayItem{
         margin-bottom:0rem;
    }
}
</style>